import { fromJS } from 'immutable';

export function getUrlParams(params) {
  const v = window.location.search.match(new RegExp(`(?:[?&]${params}=)([^&]+)`));
  return v ? v[1] : undefined;
}

export function getParamsUrlString(url, params) {
  if (url) {
    const v = url.match(new RegExp(`(?:[?&]${params}=)([^&]+)`));
    return v ? v[1] : undefined;
  }
  return undefined;
}

export function getUrlArray() {
  return window.location.pathname.split('/');
}

function validateExists(id, mainItems) {
  const items = mainItems || [];
  let found = false;
  // Kiểm tra có bị trùng item không
  items.forEach(item => {
    if (parseInt(item) === parseInt(id)) {
      found = true;
    }
  });
  return found;
}

export function removeArray(array, sl) {
  const newArray = [];
  let i = array.length - 1;
  while (i > 0) {
    newArray.unshift(array[i]);
    if (i - sl <= 0) {
      newArray.unshift(array[0]);
    }
    i -= sl;
  }
  return newArray;
}

export function customFieldProduct(items, mainItems) {
  const mainItemToJs = mainItems ? mainItems.toJS() : [];
  for (let i = 0; i < items.length; i++) {
    // const defaultImage = item.images[0] ? item.images[0].originalSrc : '';
    const id = items[i].id;
    // const variants = item.variants;
    const newId = id.substr(id.lastIndexOf('/') + 1);
    const isExists = validateExists(newId, mainItems);
    if (!isExists) {
      mainItemToJs.unshift(parseInt(newId));
    }
  }
  return mainItemToJs;
}

export function customFieldCollection(items, mainItems) {
  const mainItemToJs = mainItems ? mainItems.toJS() : [];
  items.forEach(async item => {
    const id = item.id;
    const newId = id.substr(id.lastIndexOf('/') + 1);
    const isExists = validateExists(newId, mainItems);
    if (!isExists) {
      mainItemToJs.unshift(parseInt(newId));
    }
  });
  return mainItemToJs;
}
// log

export function timeAgo(date) {
  const dates = new Date(date).getTime();
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  const year = day * 365;

  const suffix = ' ago';

  const elapsed = Math.floor((Date.now() - dates) / 1000);

  if (elapsed < minute) {
    return 'just now';
  }

  // get an array in the form of [number, string]
  const a = (elapsed < hour && [Math.floor(elapsed / minute), 'minute']) ||
    (elapsed < day && [Math.floor(elapsed / hour), 'hour']) ||
    (elapsed < month && [Math.floor(elapsed / day), 'day']) ||
    (elapsed < year && [Math.floor(elapsed / month), 'month']) || [Math.floor(elapsed / year), 'year'];

  // pluralise and append suffix
  return `${a[0]} ${a[1]}${a[0] === 1 ? '' : 's'} ${suffix}`;
}

export function getDateBefore(date, number) {
  const dates = new Date(date).getTime();
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;

  const dateBefore = new Date(dates - number * day * 1000);

  let timeStart;
  let timeEnd;

  if (dateBefore.getMonth() + 1 < 10) {
    timeStart = `${dateBefore.getFullYear()}-0${dateBefore.getMonth() + 1}-${
      dateBefore.getDate() < 10 ? '0' : ''
    }${dateBefore.getDate()}`;
  } else {
    timeStart = `${dateBefore.getFullYear()}-${dateBefore.getMonth() + 1}-${
      dateBefore.getDate() < 10 ? '0' : ''
    }${dateBefore.getDate()}`;
  }

  if (date.getMonth() + 1 < 10) {
    timeEnd = `${date.getFullYear()}-0${date.getMonth() + 1}-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
  } else {
    timeEnd = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
  }

  const data = {
    now: `${timeEnd}`,
    before: `${timeStart}`
  };

  return data;
}

export function formatDate(dates) {
  const newDate = dates || [];
  const data = newDate.map(date => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric'
    }).format(new Date(date));
  });

  return data;
}

export function formatMonth(dates = []) {
  const newDate = dates || [];
  const data = newDate.map(date => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short'
    }).format(new Date(date));
  });

  return data;
}

export function getImageResize(url, size = '') {
  const pos = url.lastIndexOf('.');
  const length = url.length;
  const firstString = url.substr(0, pos);
  const lastString = url.substr(pos, length - pos);
  const data = firstString + size + lastString;

  return data;
}

export function fixDataQuickView(value) {
  if (value === 'white' || value === 'black') {
    return fromJS([value]);
  }
  return value;
}

export function convertProductListToIdList(productList) {
  // Check first element if is an object then handle convert to array id string
  const newArray = [];
  if (productList.length > 0 && productList[0].id) {
    for (let i = 0; i < productList.length; i++) {
      newArray.push(parseInt(productList[i].id));
    }
  }
  if (newArray.length > 0) return newArray;
  return productList;
}

/**
 * Limit loop using requestAnimationFrame if timeOut have param, interval will by timeOut config
 * @param fn
 * @param fps : number = 30 fps
 * @param timeOut
 */
export function limitLoop(fn, fps = 30, timeOut = null) {
  // Use var then = Date.now(); if you
  // don't care about targeting < IE9
  let then = new Date().getTime();
  const interval = timeOut || 1000 / fps;

  return (function loop() {
    window.requestAnimationFrame(loop);
    // again, Date.now() if it's available
    const now = new Date().getTime();
    const delta = now - then;
    if (delta > interval) {
      // Update time
      // now - (delta % interval) is an improvement over just
      // using then = now, which can end up lowering overall fps
      then = now - (delta % interval);
      // call the fn
      fn();
    }
  })(0);
}
